import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                <i className="ri-fire-line"></i>
                焦点爆料
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
                今日热门爆料
              </h2>
            </div>
            <div className="hidden sm:flex items-center gap-2 text-sm text-foreground-500">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              实时更新中
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselItems.map((item) => (
              <article
                key={item.id}
                className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="relative overflow-hidden h-52">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    width="400"
                    height="260"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-xs font-semibold text-background-50 bg-primary-500 rounded-full">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 bg-background-950/70 rounded-full text-xs text-background-50">
                    <i className="ri-fire-line text-xs"></i>
                    {item.heat}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-sans font-bold text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 line-clamp-2 mb-3">
                    {item.summary}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {item.time}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      讨论中
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}